import {createApp, markRaw} from 'vue'
import {createPinia} from 'pinia'

import App from './App.vue'
import router from './router'
import PrimeVue from 'primevue/config';
import '@/assets/style/tokens/index.css'
// Doküman'ın kendisi (html/body) — tokenlardan hemen sonra, legacy'den önce.
import '@/assets/style/base.css'
import '@/assets/sass/ms-scroll.scss'
import '@/assets/sass/global.scss'
import {focusDirective} from "@shared/directives";
import {ScreenNs} from "@shared/types";
import LucideIcon from "@shared/icons/icon.vue";


const DEFAULT_TITLE = 'metastory · Empowering Product Owner with AI'

let link: any = document.querySelector("link[rel~='icon']")
if (!link) {
  link = document.createElement('link')
  link.rel = 'icon'
  document.head.appendChild(link)
}


if (import.meta.env.MODE === 'production') {
  const script = document.createElement('script');
  script.src = "https://cdn-eu.pagesense.io/js/zohh6wyt/c2c789b587a640a6b477a184327eea1f.js";
  document.head.appendChild(script);
}

router.beforeEach((to, from, next) => {
  const title = to.meta.title
  const titleFromParams = to.params.pageTitle
  if (title) {
    (document.title as any) = title
  }
  if (titleFromParams) {
    document.title = `${titleFromParams} - ${document.title}`
  }

  if (!titleFromParams && !title) {
    document.title = DEFAULT_TITLE
  }
  next()
})


const pinia = createPinia()
pinia.use(({store}) => {
  store.router = markRaw(router)
});


const app = createApp(App)

const assetUrls = import.meta.glob('/src/assets/**/*.{png,jpg,jpeg,gif,webp,svg,avif,ico}', {eager: true, query: '?url', import: 'default'});

app.config.globalProperties.$image = ((url: string) => {
  return (assetUrls[`/src/${url}`] as string) ?? new URL(`/src/${url}`, import.meta.url).href;
});

app.config.globalProperties.$filters = {
  loadImage(value: string, imageSize: ScreenNs.ImageSizes = ScreenNs.ImageSizes.Medium): string {
    return `${value}/${imageSize}`
  }
}

app.component('LucideIcon', LucideIcon)
app.directive('focus', focusDirective)
app.use(PrimeVue)
app.use(pinia)
app.use(router)

app.mount('#app')
